<template>
  <!-- 项目调研表单 -->
  <el-form ref="form" :model="form1" label-width="80px">
    <el-row>
      <el-col span="6">
        <el-form-item label="所属模块" :required="true">
          <el-select clearable  v-model="form.module" filterable placeholder="请选择所属模块">
            <el-option
              v-for="item in tboptions.module"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col span="6">
        <el-form-item label="类型" :required="true">
          <el-select clearable  v-model="form.type" placeholder="请选择类型">
            <el-option
              v-for="item in tboptions.type"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col span="6">
        <el-form-item label="任务序号">
          <el-input v-model="form.sqnum"></el-input>
        </el-form-item>
      </el-col>
      <el-col span="6" class="shzt" v-show="form.shzt">
        审核状态: <span>{{ form.shzt }}</span>
      </el-col>
    </el-row>
    <el-form-item label="任务明细">
      <el-input v-model="form.taskdetail" type="textarea" rows="5"></el-input>
    </el-form-item>
    <el-form-item label="任务说明">
      <el-input v-model="form.instructions" type="textarea" rows="5"></el-input>
    </el-form-item>
    <el-row>
      <el-col span="7">
        <el-form-item label="负责人" :required="true">
          <el-select clearable  v-model="form.fzr" placeholder="请选择负责人">
            <el-option
              v-for="item in tboptions.fzr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col span="7">
        <el-form-item label="是否调研">
          <el-switch v-model="form.dy"></el-switch>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  props: {
    tboptions: {
      // 下拉选项
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: {},
      form1: {}
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/styles/mixin.scss';
.el-form {
  .shzt {
    height: 42px;
    line-height: 42px;
    padding: 0 20px;
    font-weight: bold;
    span {
      color: #1b6aaa;
    }
  }
  /deep/ .el-form-item {
    .el-form-item__label {
      font-weight: bold;
    }
  }
}
</style>
